
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ICommunityIntegrationData } from '@/model/Community/communityInterfaces';

const communityModule = namespace('communityModule');

const CHANNELS: Array<{ type: 'email' | 'sms' | 'push'; icon: string }> = [
  { type: 'email', icon: 'mdi-email-outline' },
  { type: 'sms', icon: 'mdi-message-text-outline' },
  { type: 'push', icon: 'mdi-cellphone-message' },
];

@Component({ name: 'NotificationTemplatesPanel' })
export default class NotificationTemplatesPanel extends Vue {
  @Prop({ required: true })
  protected communityId!: number;

  @communityModule.Action('fetchCommunityIntegrationsData')
  private fetchCommunityIntegrationsData!: (communityId: number) => Promise<ICommunityIntegrationData[]>;

  protected loading: boolean = true;
  protected failed: boolean = false;
  protected templates: ICommunityIntegrationData[] = [];

  get channels() {
    return CHANNELS.map((channel) => ({
      ...channel,
      templates: this.templates.filter((row: ICommunityIntegrationData) => row.type === channel.type),
    }));
  }

  created() {
    this.fetchCommunityIntegrationsData(this.communityId)
      .then((templates: ICommunityIntegrationData[]) => { this.templates = templates; })
      .catch(() => { this.failed = true; })
      .finally(() => { this.loading = false; });
  }
}
